import React, { memo } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { styled } from 'linaria/react';

type StepGridProps = {
  children: React.ReactNode;
  stepNumber: number;
};

type StyledSTepGridProps = {
  stepNumber: number;
} & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export const StyledStepGrid = styled.div<StyledSTepGridProps>`
  display: grid;
  grid-template-columns: ${({ stepNumber }: StyledSTepGridProps) => `repeat(${stepNumber}, 1fr)`};
  width: 100%;

  @media (--from-tablet) {
    column-gap: 24px;
  }

  @media (--only-mobile) {
    grid-template-columns: 1fr;
    grid-template-rows: auto;
    row-gap: 24px;
  }
`;

export const stepGridStylesMap: Record<number, string> = {
  4: css`
    @media (--only-tablet) {
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto;
      column-gap: 16px;
      row-gap: 24px;
    }
  `,
  5: css`
    @media (--only-tablet) {
      grid-template-columns: repeat(3, 204px);
      grid-template-rows: auto;
      row-gap: 48px;
    }
  `,
};

export const StepGrid: React.FC<StepGridProps> = memo(({ children, stepNumber }) => (
  <StyledStepGrid className={cn(stepGridStylesMap[stepNumber])} stepNumber={stepNumber}>
    {children}
  </StyledStepGrid>
));
